"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputTextArea = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

function InputTextArea(_a) {
  var label = _a.label,
      name = _a.name,
      LeftComponent = _a.LeftComponent,
      RightComponent = _a.RightComponent,
      _a$errors = _a.errors,
      errors = _a$errors === void 0 ? {} : _a$errors,
      disabled = _a.disabled,
      textHelper = _a.textHelper,
      classNames = _a.classNames,
      showError = _a.showError,
      showIconError = _a.showIconError,
      rounded = _a.rounded,
      props = __rest(_a, ["label", "name", "LeftComponent", "RightComponent", "errors", "disabled", "textHelper", "classNames", "showError", "showIconError", "rounded"]);

  var isError = !!errors[name];
  var helperText = showError && errors[name] || textHelper;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.wrapper
  }, label && react_1.default.createElement("label", {
    htmlFor: name,
    className: "block text-sm font-medium text-gray-700 flex-grow-0 ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.label)
  }, label), react_1.default.createElement("div", {
    className: "".concat(isError && 'iconLeftError', " mt-1 relative ").concat(rounded && 'rounded-md', " shadow-sm")
  }, LeftComponent && react_1.default.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.leftComponent)
  }, LeftComponent), react_1.default.createElement("textarea", Object.assign({
    name: name,
    disabled: !!disabled,
    className: "h-12 block w-full ".concat(rounded && 'rounded-md', " ").concat(isError ? 'pr-10 text-red-500 placeholder-red-500 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm border-red-500 border border-solid' : 'focus:outline-none focus:ring-gray-200 focus:border-gray-300 sm:text-sm border-gray-300 border border-solid placeholder-gray-400', " ").concat(LeftComponent ? 'pl-10' : 'pl-3', " ").concat(disabled ? 'bg-gray-200' : '', " ").concat(classNames === null || classNames === void 0 ? void 0 : classNames.input),
    "aria-invalid": "true",
    "aria-describedby": "email-error"
  }, props)), isError && showIconError && react_1.default.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
  }, react_1.default.createElement("svg", {
    className: "w-5 h-5 text-red-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }))), RightComponent && !isError && react_1.default.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.rightComponent)
  }, RightComponent)), helperText && react_1.default.createElement("div", {
    className: "flex-grow-0 text-sm text-left not-italic font-normal ".concat(showError ? 'text-error' : 'text-gray-400', " mt-1 ").concat(classNames === null || classNames === void 0 ? void 0 : classNames.helperText)
  }, helperText)));
}

exports.InputTextArea = InputTextArea;
InputTextArea.propTypes = {
  /**
   * A Icon input left
   */
  LeftComponent: prop_types_1.default.element,

  /**
   * A Icon input right
   */
  RightComponent: prop_types_1.default.element,

  /**
   * A label input
   */
  label: prop_types_1.default.string,

  /**
   * A type input
   */
  type: prop_types_1.default.string,

  /**
   * A name input
   */
  name: prop_types_1.default.string,

  /**
   * A id input
   */
  id: prop_types_1.default.string,

  /**
   * A placeholder input
   */
  placeholder: prop_types_1.default.string,

  /**
   * A flag to check error input
   */
  errors: prop_types_1.default.object,

  /**
   * A flag to disable input
   */
  disabled: prop_types_1.default.bool,

  /**
   * Text helper
   */
  textHelper: prop_types_1.default.string,

  /**
   * Value input
   */
  value: prop_types_1.default.string,

  /**
   * function onchange
   */
  handleChange: prop_types_1.default.func,

  /**
   * Show error
   */
  showError: prop_types_1.default.bool,

  /**
   * Show error icon
   */
  showIconError: prop_types_1.default.bool,

  /**
   * Show rounded input
   */
  rounded: prop_types_1.default.bool,

  /**
   * Custom style by class name
   */
  classNames: prop_types_1.default.shape({
    wrapper: prop_types_1.default.string,
    label: prop_types_1.default.string,
    leftComponent: prop_types_1.default.string,
    input: prop_types_1.default.string,
    rightComponent: prop_types_1.default.string,
    helperText: prop_types_1.default.string
  })
};
InputTextArea.defaultProps = {
  LeftComponent: undefined,
  RightComponent: undefined,
  label: undefined,
  type: 'text',
  name: undefined,
  id: undefined,
  placeholder: 'Name',
  errors: {},
  value: '',
  handleChange: undefined,
  showIconError: true,
  rounded: false
};